export const getStepProgressData = (currentStep: number, accessCode?: string) => {
    const STEPS = [
        'main.progress.purchase',
        'main.progress.register',
        'main.progress.download',
        ...(accessCode ? ['main.progress.copyCode'] : []),
        'basics.login',
    ];

    return STEPS.map((label, index) => ({
        id: index + 1,
        isCurrentStep: index === currentStep,
        isFinished: index < currentStep,
        label,
    }));
};

export const getTitleKey = (isAppDownloaded: boolean, accessCode?: string) => {
    if (isAppDownloaded) return 'main.title.isDownloaded';

    return accessCode ? 'main.title.notDownloaded' : 'main.title.notDownloadedAndWithoutAccessCode';
};
